import {
  ListItemIcon as MuiListItemIcon,
  ListItemIconProps as MuiListItemIconProps,
} from '@mui/material';

export type ListItemIconProps = MuiListItemIconProps;

export const ListItemIcon = MuiListItemIcon;
